module.exports = __webpack_public_path__ + "media/images/young_pin_design_award_icon-5058f7a3ee8e26aed7f01fe36ee97f71.png";